export enum ContentType {
    SEARCH,
    ADD,
    EDIT,
}

